import { Typography, styled } from '@mui/material';

const StyledTypography = styled(Typography)({
  '& span': {
    background:
      'var(--Alert-Sunset-Orange, linear-gradient(175deg, #FF9A9A -9.81%, #FF5858 96.32%))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
});

export default StyledTypography;
